import { CSSResultArray, TemplateResult, html } from 'lit';
import { OutlineElement } from '@phase2/outline-core';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './pc-chip-card.css.lit';
import { AdoptedStyleSheets } from '@phase2/outline-adopted-stylesheets-controller';
import globalStyles from './pc-chip-card.lightDom.css.lit';
/**
 * The PcChipCard component
 * @element pc-chip-card
 */
@customElement('pc-chip-card')
export class PcChipCard extends OutlineElement {
  static styles: CSSResultArray = [componentStyles];
  adoptedStylesheets: AdoptedStyleSheets;

  @property({ type: Boolean })
  stacked: boolean;

  connectedCallback() {
    super.connectedCallback();
    this.adoptedStylesheets = new AdoptedStyleSheets(globalStyles);
    this.addController(this.adoptedStylesheets);
  }

  render(): TemplateResult {
    return html`
      <section class="pc-chip-card">
        <slot name="eyebrow"></slot>
        <div class="pc-chip-card--list">
          <slot name="list"></slot>
        </div>
      </section>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-chip-card': PcChipCard;
  }
}
